var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPeopleFilled(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "People Filled"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\xF0\x9F\x8E\xA8 Color",
    d: "M2.91797 11.6667L11.2513 11.6675C11.9007 11.6675 12.435 12.1636 12.4956 12.7972L12.5013 12.9175V14.5833C12.5005 17.5 9.40464 18.3333 7.08464 18.3333C4.81619 18.3333 1.80521 17.5366 1.67251 14.7747L1.66797 14.5833V12.9167C1.66797 12.2673 2.16402 11.733 2.79764 11.6724L2.91797 11.6667ZM12.908 11.6667H17.0846C17.734 11.6667 18.2683 12.162 18.3289 12.7962L18.3346 12.9167V14.1667C18.3338 16.7183 15.953 17.5 14.168 17.5C13.6013 17.5 12.9755 17.42 12.3846 17.2317C12.9286 16.6064 13.2815 15.8123 13.3291 14.8167L13.3346 14.5833V12.9167C13.3346 12.5047 13.2102 12.124 13.0021 11.8013L12.908 11.6667ZM7.08464 2.5C9.15547 2.5 10.8346 4.17917 10.8346 6.25C10.8346 8.32083 9.15547 10 7.08464 10C5.0138 10 3.33464 8.32083 3.33464 6.25C3.33464 4.17917 5.0138 2.5 7.08464 2.5ZM14.5846 4.16667C16.1955 4.16667 17.5013 5.4725 17.5013 7.08333C17.5013 8.69417 16.1955 10 14.5846 10C12.9738 10 11.668 8.69417 11.668 7.08333C11.668 5.4725 12.9738 4.16667 14.5846 4.16667Z",
    fill: "#1D72E9"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPeopleFilled);
export default __webpack_public_path__ + "static/media/people-filled.ba7bb98e312ae2f637493dbf718f7fb4.svg";
export { ForwardRef as ReactComponent };